const Constants = {
    AdminRole: 'FMHelpdesk.Users'
}

export default Constants